import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Graphic} from './graphic.service';
import {CacheRegistrationService} from '@uofu-uss-aux/software-catalog-ng-core';

@Injectable({
  providedIn: 'root'
})
export class GraphicDataService {

  public static readonly baseUrl = '/api/graphic';

  constructor(private readonly http: HttpClient,
              private readonly cacheRegistrationService: CacheRegistrationService) {
    cacheRegistrationService.addToCache(GraphicDataService.baseUrl);
  }

  fetchGraphic(id: number): Observable<Graphic> {
    return this.http.get<Graphic>(`${GraphicDataService.baseUrl}/${id}`);
  }
}
